import { controlLog } from "../../types/interfaces";
import { PostResult } from "../../types/types";


const backendURL = "/api/"

async function getStationName(sid:String): Promise<string> {
    const res = await fetch(backendURL + "getStationData/" + sid)
    const data = await res.json()
    return data[0].stationName
}

async function postStationControlLog(data:controlLog): Promise<PostResult> {
    const res = await fetch(backendURL + "postControlLog/", {
        method: "POST",
        headers: {
            "Access-Control-Allow-Origin": window.location.hostname,
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data)
    })
    const success = await res.json();
    return success
}

export {
    getStationName,
    postStationControlLog
}